import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";

import { StudioTheme as THEME } from "@certa/common/constants/studioSettings";
export { StudioTheme as THEME } from "@certa/common/constants/studioSettings";

// Dark Pallete is not being used, so when the designs are updated then update them with tokens
export const DARK_PALETTE = {
  BACKGROUND: "#0d1117",
  BACKGROUND_DOTS: "#0a141c",

  LINKED_OBJECT_NAME: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  LINKED_OBJECT_VARIABLE_NAME: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_200,
  LINKED_OBJECT_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,

  SWIMLANE_BACKGROUND: "#1a1e26",
  SWIMLANE_TITLE: "#9aa3b6",
  SWIMLANE_ICON: "#9aa3b6",
  SWIMLANE_CARET: "#9aa3b6",
  SWIMLANE_SELECTED_BORDER_COLOR: "#ffcc00",

  STEP_BACKGROUND: "#282e36",
  STEP_FLOW_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  STEP_FLOW_SELECTED_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,
  STEP_TITLE: "#acb4c0",
  STEP_ICON: "#acb4c0",
  STEP_CARET: "#acb4c0",
  STEP_SELECTED_BORDER_COLOR: "#ffcc00",
  STEP_BORDER_COLOR: "#1a1e26",

  FIELD_BACKGROUND: "#363e46",
  FIELD_TITLE: "#bec5ca",
  FIELD_ICON: "#bec5ca",
  FIELD_SELECTED_BORDER_COLOR: "#ffcc00",
  FIELD_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_400,
  FILED_BACKGROUND_HOVER_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_100,
  FIELD_HIDDEN_BACKGROUND_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_400,

  ADD_FIELD_COLOR: "#8892ac",
  ADD_FIELD_ICON: "#8892ac",

  ADD_STEP_COLOR: "#8892ac",
  ADD_STEP_ICON: "#8892ac",

  ADD_SWIMLANE_BORDER: "#8892ac",
  ADD_SWIMLANE_ICON: "#8892ac",
  ADD_SWIMLANE_COLOR: "#8892ac",
  ADD_SWIMLANE_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,

  LINE_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  LINE_SELECTED_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,

  RULE_INDICATOR_UPSTREAM_ICON_COLOR: "#00ADAD",
  RULE_INDICATOR_DOWNSTREAM_ICON_COLOR: "#FFCC00",
  RULE_INDICATOR_CONTAINER_BG_COLOR: "#0A141C",
  RULE_INDICATOR_FIELD_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_300,
  RULE_INDICATOR_STEP_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  RULE_INDICATOR_TITLE_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,

  ADD_ACTION_BORDER_COLOR: "#49a55b",
  UPDATE_ACTION_BORDER_COLOR: "#fcac27",
  DELETE_ACTION_BORDER_COLOR: "#fb2e3d",
  HOVER_ACTION_BORDER_COLOR: "#65c6ff",

  REQUIRED_ASTERISK_COLOR: CATALYST_COLORS_WITH_HEXCODES.RED_400,

  FLOW_SWIMLANE_RULE_INDICATOR_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_600,
  FLOW_SWIMLANE_SELECTED_RULE_INDICATOR_COLOR:
    CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  FLOW_SWIMLANE_RULE_INDICATOR_TEXT_COLOR:
    CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100
};

export const LIGHT_PALETTE = {
  // These are not available in catalyst tokens,
  BACKGROUND: "#F1F1F1",
  BACKGROUND_DOTS: "#cfd9e0",

  LINKED_OBJECT_NAME: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_700,
  LINKED_OBJECT_VARIABLE_NAME: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  LINKED_OBJECT_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,

  SWIMLANE_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  SWIMLANE_TITLE: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  SWIMLANE_ICON: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  SWIMLANE_CARET: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  SWIMLANE_SELECTED_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,

  STEP_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_300,
  STEP_FLOW_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  STEP_FLOW_SELECTED_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,
  STEP_TITLE: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  STEP_ICON: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  STEP_CARET: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  STEP_SELECTED_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  STEP_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,

  FIELD_BACKGROUND: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  FIELD_TITLE: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  FIELD_ICON: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,
  FIELD_SELECTED_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  FIELD_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_400,
  FILED_BACKGROUND_HOVER_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_100,
  FIELD_HIDDEN_BACKGROUND_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_500,

  ADD_FIELD_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  ADD_FIELD_ICON: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,

  ADD_STEP_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  ADD_STEP_ICON: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,

  ADD_SWIMLANE_BORDER: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  ADD_SWIMLANE_ICON: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  ADD_SWIMLANE_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  ADD_SWIMLANE_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,

  LINE_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_600,
  LINE_SELECTED_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  RULE_INDICATOR_UPSTREAM_ICON_COLOR: CATALYST_COLORS_WITH_HEXCODES.TEAL_500,
  RULE_INDICATOR_DOWNSTREAM_ICON_COLOR:
    CATALYST_COLORS_WITH_HEXCODES.ORANGE_400,
  RULE_INDICATOR_CONTAINER_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_300,
  RULE_INDICATOR_FIELD_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_300,
  RULE_INDICATOR_STEP_BG_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100,
  RULE_INDICATOR_TITLE_COLOR: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800,

  ADD_ACTION_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.GREEN_400,
  UPDATE_ACTION_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.ORANGE_400,
  DELETE_ACTION_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.RED_400,
  HOVER_ACTION_BORDER_COLOR: CATALYST_COLORS_WITH_HEXCODES.TEAL_400,

  REQUIRED_ASTERISK_COLOR: CATALYST_COLORS_WITH_HEXCODES.RED_400,

  FLOW_SWIMLANE_RULE_INDICATOR_COLOR: CATALYST_COLORS_WITH_HEXCODES.BRAND_600,
  FLOW_SWIMLANE_SELECTED_RULE_INDICATOR_COLOR:
    CATALYST_COLORS_WITH_HEXCODES.BRAND_400,
  FLOW_SWIMLANE_RULE_INDICATOR_TEXT_COLOR:
    CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_100
};

export const PALETTE: Record<THEME, typeof LIGHT_PALETTE> = {
  [THEME.DARK]: DARK_PALETTE,
  [THEME.LIGHT]: LIGHT_PALETTE
};
